import { makeAutoObservable } from 'mobx';
import { createHealthDataPoint, HealthDataPoint } from './HealthDataPoint';
import { HealthDataPointCorrelationType } from './HealthDataPointCorrelationType';
import { HealthDataPointQuantity, createHealthDataPointQuantity } from './HealthDataPointQuantity';
import { HttpBackend } from '../../Services/Http/HttpBackend';
import { notUndefined } from '../../Utils/notUndefined';
import { HealthDataPointQuantityType } from './HealthDataPointQuantityType';
import { HealthDataPointType } from './HealthDataPointType';

const correlationSort = [
  HealthDataPointQuantityType.bloodPressureSystolic,
  HealthDataPointQuantityType.bloodPressureDiastolic,
];

export type HealthDataPointCorrelation = HealthDataPoint & {
  type: HealthDataPointCorrelationType;
  values: HealthDataPointQuantity[];
  getValue(metric?: boolean): number[];
  getUnit(metric?: boolean): string | undefined;
  save(): Promise<HealthDataPointCorrelation>;
};

export function createHealthDataPointCorrelation(
  json?: Partial<HealthDataPointCorrelation>,
): HealthDataPointCorrelation {
  return makeAutoObservable({
    ...createHealthDataPoint(json),
    pointType: HealthDataPointType.correlation,
    type: json?.type ?? HealthDataPointCorrelationType.bloodPressure,
    values: (json?.values || []).map((q) => createHealthDataPointQuantity(q)),

    getValue(metric: boolean = true): number[] {
      return this.values
        .slice()
        .sort((a, b) => correlationSort.indexOf(a.type) - correlationSort.indexOf(b.type))
        .map((v) => v.getValue(metric));
    },

    getUnit(metric: boolean = true): string | undefined {
      return [
        ...new Set(
          this.values
            .slice()
            .sort((a, b) => correlationSort.indexOf(a.type) - correlationSort.indexOf(b.type))
            .map((v) => v.getUnit(metric))
            .filter(notUndefined),
        ),
      ].join('/');
    },

    save(): Promise<HealthDataPointCorrelation> {
      return HttpBackend.post(`/athlete/health-data`, this)
        .then((result) => {
          this.id = result.id || this.id;
        })
        .then(() => this);
    },

    update(): Promise<any> {
      return HttpBackend.put(`/athlete/health-data/${this.id}`, this);
    },
  });
}
